<template>
    <div class="d-flex">
        <navigator :flag="navFlag" />
        <div class="surveys-page">
            <div class="title-header">
                <h1>{{ projectName }}</h1>
            </div>
            <div class="content-wrapper">
                <div class="surveys-search-bar">
                    <b-form-input 
                        v-model="searchTerm" 
                        placeholder="Search surveys by name..." 
                        class="text-input"
                    ></b-form-input>
                </div>
                <div class="survey-cards-container">
                    <div v-for="(survey, i) in filteredSurveys" :key="i" class="survey-card">
                        <div class="survey-info">
                            <div class="survey-name">{{ survey.name }}</div>
                            <div class="survey-description">{{ survey.description }}</div>
                        </div>
                        <b-button class="complete-survey-button" v-b-modal="modalId(i)">
                            Complete Survey
                        </b-button>
                        <!-- Preview survey modal - opens when the above button is clicked -->
                        <b-modal :id="'preview-modal-' + i" title="Preview Survey" size="xl">
                            <CompleteSurvey :questions="survey.questions" :response="response"></CompleteSurvey>
                            <template #modal-footer>
                                <div class="modal-footer-actions">
                                    <b-button class="submit-button" v-on:click="() => submitSurvey(survey, i)">
                                        Submit Survey
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>
                    </div>
                    <div v-if="filteredSurveys.length == 0" class="no-surveys">
                        <img src="../../assets/Not Found.png" class="empty-state-image">
                        <div class="empty-state-text">No surveys found</div>
                        <div class="empty-state-subtext">Try adjusting your search</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompleteSurvey from './CompleteSurvey.vue'
import navigator from '../layout/NavBarNew.vue'
import Template from '../../Firestore/Template.js'
import Response from '../../Firestore/Response.js'
import API_URL from '../../api/config.js'

export default {
    name: "ProjectSurveys",
    components: {
        navigator,
        CompleteSurvey
    },
    data() {
        return {
            userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1, // 0: Tester, 1: dev, 2: Admin
            searchTerm: "",
            navFlag: 0,
            // get from db after
            surveys: [],
            projectName: "",
            response: { 'responses': [] }
        }
    },
    computed: {
        filteredSurveys() {
            return this.surveys.filter(survey =>
                survey.name.toLowerCase().includes(this.searchTerm.toLowerCase())
            )
        }
    },
    mounted() {
        // redirect to login if the user is not logged in
        if (window.localStorage.getItem("userType")) {
            this.userType = parseInt(window.localStorage.getItem("userType"));
        } else {
            this.$router.push({
                name: 'login',
            })
        }
        this.projectName = window.localStorage.getItem('gameName')
        Response.getUnfinishedSurveysByTesterProject(window.localStorage.getItem('userId'), window.localStorage.getItem('gameId')).then(res => {
            this.surveys = res.data
        })
    },
    methods: {
        modalId(i) {
            return 'preview-modal-' + i
        },
        async submitSurvey(survey, index) {
            try {
                const uid = window.localStorage.getItem('userId');
                //wait for response to save
                await Response.saveResponses(survey.sID, uid, this.response.responses)
                //wait for survey counter to increment
                const res = await Response.incrementSurveysCompleted(uid)
                //Show Achievement popup if there is an achivement
                if (res && res.achieved){
                    this.$snackbar.showSnackbar(`New Achievement: Submit ${res.val} Survey${res.val !== 1 ? 's' : ''}! `, "#28a745");
                }

                this.surveys.splice(index, 1)
                this.$bvModal.hide('preview-modal-' + index)
            } catch(error){
                console.error("Failed to submit survey:", error);
                this.$snackbar.showSnackbar("Failed to submit survey. Please try again.", "#dc3545");
                return;     //prevents the email from sending if error occurred
            }
            try{
                const uid = window.localStorage.getItem('userId');
                const gid = window.localStorage.getItem('gameId');
                //emailing part
                const name = "tester";
                const message = uid;
                const response = await fetch(`${API_URL}/email/devs/${gid}/survey-notif`, {
                    method: 'POST',
                    headers:{
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({name, message})
                })
                const data = await response.json();
                if (!data.success) {
                    throw new Error(data.error || "Failed sending email")
                }
                console.log("User recieved email");
            }catch(error){
                console.error("Failed to send developer notification email:", error);
            }
        }
    }
}
</script>

<style scoped>
/* Base font for entire page */
.surveys-page {
    font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    background-color: #F5F5F5;
    overflow-y: auto;
}

.title-header {
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 85px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    flex-shrink: 0;
}

.title-header h1 {
    color: #FF7222;
    font-weight: 600;
    font-size: 28px;
    margin: 0;
    letter-spacing: -0.5px;
}

.content-wrapper {
    padding: 24px;
    max-width: 1600px;
    margin: 0 auto;
    width: 100%;
}

.surveys-search-bar {
    margin-bottom: 20px;
}

.text-input.form-control {
    background-color: white !important;
    border-radius: 10px !important;
    color: #333 !important;
    border: 1px solid #E0E0E0 !important;
    padding: 12px 16px !important;
    font-size: 15px;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.text-input.form-control::placeholder {
    color: #999 !important;
}

.text-input.form-control:focus {
    border-color: #FF7222 !important;
    box-shadow: 0 0 0 3px rgba(255, 114, 34, 0.1) !important;
    outline: none;
}

.survey-cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
    width: 100%;
}

.survey-card {
    background-color: white;
    border-radius: 12px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.2s ease;
    min-height: 180px;
}

.survey-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

.survey-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
    flex-grow: 1;
}

.survey-name {
    color: #FF7222;
    font-weight: 600;
    font-size: 18px;
    line-height: 1.3;
    letter-spacing: -0.2px;
}

.survey-description {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.complete-survey-button {
    background: linear-gradient(135deg, #FF7222, #FF8E4D) !important;
    border: none !important;
    border-radius: 8px !important;
    height: 44px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 15px;
    color: white;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(255, 114, 34, 0.3);
    cursor: pointer;
}

.complete-survey-button:hover {
    background: linear-gradient(135deg, #FF8E4D, #FFA066) !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(255, 114, 34, 0.4);
}

.complete-survey-button:active,
.complete-survey-button:focus {
    background: linear-gradient(135deg, #FF7222, #FF8E4D) !important;
    box-shadow: 0 2px 6px rgba(255, 114, 34, 0.3) !important;
}

.modal-footer-actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button {
    background: linear-gradient(135deg, #FF7222, #FF8E4D) !important;
    border: none !important;
    border-radius: 8px !important;
    height: 44px !important;
    padding: 0 32px !important;
    font-weight: 600;
    font-size: 15px;
    color: white;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(255, 114, 34, 0.3);
}

.submit-button:hover {
    background: linear-gradient(135deg, #FF8E4D, #FFA066) !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(255, 114, 34, 0.4);
}

.submit-button:active,
.submit-button:focus {
    background: linear-gradient(135deg, #FF7222, #FF8E4D) !important;
    box-shadow: 0 2px 6px rgba(255, 114, 34, 0.3) !important;
}

.no-surveys {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 60px 20px;
    min-height: 400px;
}

.empty-state-image {
    max-width: 200px;
    opacity: 0.7;
    margin-bottom: 20px;
}

.empty-state-text {
    font-size: 20px;
    font-weight: 600;
    color: #666;
    margin-bottom: 8px;
}

.empty-state-subtext {
    font-size: 15px;
    color: #999;
}

/* Responsive adjustments */
@media only screen and (max-width: 768px) {
    .content-wrapper {
        padding: 16px;
    }

    .title-header h1 {
        font-size: 24px;
    }

    .survey-cards-container {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .survey-card {
        min-height: 160px;
    }
}

@media only screen and (min-width: 769px) and (max-width: 1200px) {
    .survey-cards-container {
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    }
}

@media only screen and (min-width: 1201px) {
    .survey-cards-container {
        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    }
}
</style>


// WEBPACK FOOTER //
// src/components/game-dashboard/ProjectSurveys.vue